import { JSX, ReactNode } from "react";
import { QESButton } from "@app/shared/qes-standards/Button";
import { TableType } from "@app/viewable-fields/viewableFields";

interface ProviderSearchRowProps {
  /**
   * The filter cells, each supplying its own Bootstrap column. The Apply/Clear cell is appended after them.
   */
  children: ReactNode;
  applyDisabled: boolean;
  /**
   * Bottom-aligns the buttons by default, which lines them up with inputs of equal height. Pass "center" when a
   * cell carries descriptive text below its input, so the buttons stay level with the inputs themselves.
   */
  buttonAlignment?: "center" | "end";
  /**
   * Prefixed onto the Apply/Clear test IDs. Existing values differ per consumer and QA automation depends on
   * them, so each caller passes its own.
   */
  buttonTestIdPrefix: string;
  clearDisabled: boolean;
  onApply: () => void;
  onClear: () => void;
  tableType: TableType;
}

/**
 * The Search row shared by the provider filter panels: its heading, and the Apply/Clear pair. Each consumer owns
 * its own filter cells and its own enable/disable rules, which differ too much to share.
 */
const ProviderSearchRow = (props: ProviderSearchRowProps): JSX.Element => (
  <>
    <div className="row">
      <div className="col-12">
        <label className="label-s mb-2">
          Search
        </label>
      </div>
    </div>
    <div className="row">
      {props.children}
      <div className={`col-md-3 d-flex align-items-${props.buttonAlignment ?? "end"} justify-content-center`}>
        <div>
          <QESButton
            className="pb-0"
            disabled={props.applyDisabled}
            qesTestId={`${props.buttonTestIdPrefix}--apply-${props.tableType}`}
            qesType="secondary"
            onClick={props.onApply}
          >
            Apply
          </QESButton>

          <QESButton
            className="pb-0"
            disabled={props.clearDisabled}
            qesTestId={`${props.buttonTestIdPrefix}--clear-${props.tableType}`}
            qesType="secondary-danger"
            onClick={props.onClear}
          >
            Clear
          </QESButton>
        </div>
      </div>
    </div>
  </>
);

export default ProviderSearchRow;
